module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm",
    staticClass: "addnew-from",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, _vm._l((_vm.raWData), function(item) {
    return _c('el-form-item', {
      key: item.attr,
      attrs: {
        "label": item.attrName,
        "prop": item.attr,
        "label-width": "140px"
      }
    }, [(item.attrVisible) ? _c('el-input', {
      attrs: {
        "value": "* * * * * *",
        "disabled": true
      }
    }) : (item.fieldType === 1) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 2) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable,
        "placeholder": item.placeholder
      },
      on: {
        "change": function (value) { return _vm.getPaymentMoney(value, item); }
      },
      nativeOn: {
        "keyup": function($event) {
          _vm.onInput(item)
        }
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, _vm._n($$v))
        },
        expression: "form[item.attr]"
      }
    }, [(item.unit) ? _c('template', {
      slot: "append"
    }, [_vm._v(_vm._s(item.unit) + "\n      ")]) : _vm._e()], 2) : (item.fieldType === 3 && item.valueArrMap) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "filterable": "",
        "disabled": item.nonEditable,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((item.valueArrMap), function(arr) {
      return _c('el-option', {
        key: arr.key,
        attrs: {
          "label": arr.value,
          "value": arr.key
        }
      })
    })) : (item.fieldType === 3 && item.initValue) ? _c('el-select', {
      attrs: {
        "clearable": "",
        "filterable": "",
        "disabled": item.nonEditable,
        "placeholder": item.placeholder
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArr(item.initValue)), function(option) {
      return _c('el-option', {
        key: option,
        attrs: {
          "value": option
        }
      })
    })) : (item.fieldType === 4) ? _c('el-date-picker', {
      attrs: {
        "disabled": item.nonEditable,
        "editable": item.nonEditable,
        "type": "date",
        "placeholder": "选择日期",
        "value-format": "yyyy-MM-dd"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 5 || item.fieldType === 6) ? [_c('v-upload', {
      attrs: {
        "disabled": item.nonEditable,
        "attrValue": _vm.form[item.attr],
        "defaultList": item.attrValue,
        "type": "image"
      }
    })] : (item.fieldType === 7) ? _c('el-input', {
      attrs: {
        "disabled": item.nonEditable,
        "type": "textarea",
        "placeholder": item.placeholder,
        "auto-complete": "off"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }) : (item.fieldType === 8) ? [_c('v-upload', {
      attrs: {
        "disabled": item.nonEditable,
        "attrValue": _vm.form[item.attr],
        "defaultList": item.attrValue,
        "type": "file"
      }
    }), _vm._v(" "), _c('el-checkbox-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      attrs: {
        "value": _vm.form[item.attr]
      }
    }, _vm._l((_vm.form[item.attr]), function(file, index) {
      return _c('el-checkbox', {
        key: file.attachIndex + index,
        attrs: {
          "label": file.filename
        }
      })
    }))] : (item.fieldType === 9) ? _c('el-checkbox-group', {
      attrs: {
        "disabled": item.nonEditable
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }, _vm._l((_vm.strToArr(item.initValue)), function(option, index) {
      return _c('el-checkbox', {
        key: index,
        attrs: {
          "label": option,
          "name": item.attr
        }
      })
    })) : (item.fieldType === 10) ? [_c('el-rate', {
      staticStyle: {
        "padding-top": "7px"
      },
      model: {
        value: (_vm.form[item.attr]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.attr, $$v)
        },
        expression: "form[item.attr]"
      }
    }), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      attrs: {
        "value": _vm.form[item.attr]
      }
    })] : (item.attr === 'status') ? _c('payment-status', {
      ref: "contractApi",
      refInFor: true,
      attrs: {
        "payMethodArray": _vm.payMethodArray,
        "item": item,
        "form": _vm.form
      }
    }) : _vm._e()], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e20890","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/add-new-form.vue
// module id = 1261
// module chunks = 82